// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
  background-color: black;
  color: white;
  padding: 20px 0;
  text-align: center;
}

.footer-content {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
}
.logo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-section {
  margin: 15px;
  flex: 1 1;
  min-width: 250px;
}

.footer-section h4 {
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #f1f1f1;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section li {
  margin-bottom: 10px;
}

.footer-section a {
  color: #bebdbd;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-section a:hover {
  color: #fff;
}

.social-media a {
  margin: 0 10px;
  font-size: 1.8rem;
  color: #fff;
  transition: color 0.3s;
}

.footer-links {
  margin: 20px 0;
}

.footer-links a {
  color: #bebdbd;
  margin: 0 15px;
  font-size: 0.9rem;
  text-decoration: none;
}

.footer-links a:hover {
  color: #fff;
}

.footer-bottom {
  margin-top: 20px;
  border-top: 1px solid #444;
  padding-top: 10px;
  font-size: 0.9rem;
}

/* Logo Styling */
.logo-section img {
  width: 120px;
  height: auto;
  margin-bottom: 10px;
}

.footer-logo1 {
  width: 150px;
  height: auto;
  margin-bottom: 10px;
}

.footer-text {
  font-size: 1.5rem;
  color: white;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .footer-container {
    padding-bottom: 30px;
  }
  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .footer-section {
    margin: 20px 0;
  }

  .social-media a {
    margin: 0 15px;
  }
}

@media (max-width: 480px) {
  .footer-section h4 {
    font-size: 1rem;
  }

  .footer-section a {
    font-size: 1.2rem;
  }

  .footer-links a {
    display: block;
    margin: 5px 0;
  }
}

.useful-links {
  display: none;
}

.footer-links button {
  background: none; /* Kein Hintergrund */
  border: none; /* Keine Ränder */
  color: #bebdbd; /* Textfarbe */
  cursor: pointer; /* Zeigt einen Zeiger bei Hover */
  font-size: 1rem; /* Schriftgröße */
  padding: 0; /* Kein Padding */
  margin-right: 10px; /* Abstand zwischen Buttons */
  text-decoration: none; /* Kein Unterstrich */
}

.footer-links button:hover {
  color: white; /* Hover-Farbe */
  text-decoration: none; /* Kein Unterstrich bei Hover */
}`, "",{"version":3,"sources":["webpack://./src/pages/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB,EAAE,qBAAqB;EACvC,YAAY,EAAE,iBAAiB;EAC/B,cAAc,EAAE,cAAc;EAC9B,eAAe,EAAE,iCAAiC;EAClD,eAAe,EAAE,iBAAiB;EAClC,UAAU,EAAE,iBAAiB;EAC7B,kBAAkB,EAAE,6BAA6B;EACjD,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;EACE,YAAY,EAAE,gBAAgB;EAC9B,qBAAqB,EAAE,+BAA+B;AACxD","sourcesContent":[".footer-container {\r\n  background-color: black;\r\n  color: white;\r\n  padding: 20px 0;\r\n  text-align: center;\r\n}\r\n\r\n.footer-content {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  flex-wrap: wrap;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n.logo-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.footer-section {\r\n  margin: 15px;\r\n  flex: 1;\r\n  min-width: 250px;\r\n}\r\n\r\n.footer-section h4 {\r\n  font-size: 1.2rem;\r\n  margin-bottom: 10px;\r\n  color: #f1f1f1;\r\n}\r\n\r\n.footer-section ul {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.footer-section li {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.footer-section a {\r\n  color: #bebdbd;\r\n  text-decoration: none;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.footer-section a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.social-media a {\r\n  margin: 0 10px;\r\n  font-size: 1.8rem;\r\n  color: #fff;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.footer-links {\r\n  margin: 20px 0;\r\n}\r\n\r\n.footer-links a {\r\n  color: #bebdbd;\r\n  margin: 0 15px;\r\n  font-size: 0.9rem;\r\n  text-decoration: none;\r\n}\r\n\r\n.footer-links a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.footer-bottom {\r\n  margin-top: 20px;\r\n  border-top: 1px solid #444;\r\n  padding-top: 10px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Logo Styling */\r\n.logo-section img {\r\n  width: 120px;\r\n  height: auto;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.footer-logo1 {\r\n  width: 150px;\r\n  height: auto;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.footer-text {\r\n  font-size: 1.5rem;\r\n  color: white;\r\n}\r\n\r\n/* Responsive Styles */\r\n@media (max-width: 768px) {\r\n  .footer-container {\r\n    padding-bottom: 30px;\r\n  }\r\n  .footer-content {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .footer-section {\r\n    margin: 20px 0;\r\n  }\r\n\r\n  .social-media a {\r\n    margin: 0 15px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .footer-section h4 {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .footer-section a {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .footer-links a {\r\n    display: block;\r\n    margin: 5px 0;\r\n  }\r\n}\r\n\r\n.useful-links {\r\n  display: none;\r\n}\r\n\r\n.footer-links button {\r\n  background: none; /* Kein Hintergrund */\r\n  border: none; /* Keine Ränder */\r\n  color: #bebdbd; /* Textfarbe */\r\n  cursor: pointer; /* Zeigt einen Zeiger bei Hover */\r\n  font-size: 1rem; /* Schriftgröße */\r\n  padding: 0; /* Kein Padding */\r\n  margin-right: 10px; /* Abstand zwischen Buttons */\r\n  text-decoration: none; /* Kein Unterstrich */\r\n}\r\n\r\n.footer-links button:hover {\r\n  color: white; /* Hover-Farbe */\r\n  text-decoration: none; /* Kein Unterstrich bei Hover */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
